import { Component } from '@angular/core';
import { MdDialog } from '@angular/material';
import { TdDialogService } from '@covalent/core';
import { HojaDeConsulta } from '../../../models';

@Component({
  selector: 'qs-detalleconsulta',
  template: `
    <h4 md-dialog-title class='primary'>
    <i class='fa fa-search' aria-hidden='true'></i> {{ consulta.nombre }} {{ consulta.apellidos }}
    </h4>
    <!--<md-divider></md-divider>-->
    <md-dialog-content>
      <table td-data-table>
        <th td-data-table-column>Propiedad</th>
        <th td-data-table-column>Valor</th>
        <tr td-data-table-row>
          <td td-data-table-cell >Edad</td>
          <td td-data-table-cell >{{ consulta.edad }}</td>
        </tr>
        <tr td-data-table-row>
          <td td-data-table-cell >Detalles</td>
          <td td-data-table-cell >{{ consulta.detalles }}</td>
        </tr>
         <tr td-data-table-row>
          <td td-data-table-cell >Tipo cita</td>
          <td td-data-table-cell >{{ consulta.tipoCita }}</td>
        </tr>
      </table>
    </md-dialog-content>
    <md-dialog-actions layout='row' layout-align='end center'>
      <button md-button md-dialog-close (click)="close()">Cerrar</button>
    </md-dialog-actions>
  `,
})

export class HojaDeConsultaDetalleComponent {

  public consulta: HojaDeConsulta;

  constructor(private _dialogService: TdDialogService,
   ) { }

  close(): void {
    this._dialogService.closeAll();
  }
}



// WEBPACK FOOTER //
// ./src/app/hojadeconsulta/detallehojadeconsulta/detallehojadeconsulta.component.ts